import * as React from 'react';

const noop = () => undefined;
const ctx = React.createContext({
    toasts: [],
    notify: noop,
    dismiss: noop,
    dismissAll: noop,
});
const ToastContextProvider = ctx.Provider;
ctx.Consumer;

export { ToastContextProvider, ctx, ctx as default };
//# sourceMappingURL=ToastContext.js.map
